export function initAccordion() {
  const accordions = document.querySelectorAll(".accordion");
  accordions.forEach((accordion) => {
    const button = accordion.querySelector(".accordion__button");
    const content = accordion.querySelector(".accordion__content");
    const icon = accordion.querySelector(".accordion__icon");

    button.addEventListener("click", () => {
      const isHidden = content.classList.contains("accordion--hidden");
      content.classList.toggle("accordion--hidden");
      icon.classList.toggle("accordion__icon--plus", !isHidden);
      icon.classList.toggle("accordion__icon--minus", isHidden);
    });
  });
}